$(document).ready(function () {
  if ($(".fp").length === 0) {
    return;
  }

  class fpSet {
    constructor() {
      this.def = {
        // serverPath: "http://localhost/framedPrint/",
        serverPath:
          "https://canadaphotolab.com/wp-content/themes/printspace-child/woocommerce/",
        fabric: {
          maxHeight: 300,
        },
        exportDpi: 300,
      };
      this.cur = {
        zoom: {
          min: undefined,
          max: 1,
          count: 1,
        },
        ratio: 1.5,
        angle: 0,
        size: "",
        cropId: 1,
        crop: "",
      };
      this.fabric = {
        canvas: "",
      };
      this.matte = {
        range: {
          min: 0,
          max: 5,
          step: 0.5,
        },
        colors: [
          {
            name: "white",
            hex: "#ffffff",
          },
          {
            name: "black",
            hex: "#000000",
          },
        ],
        list: [
          {
            size: 0,
            price: 0,
          },
          {
            size: 2,
            price: 0,
          },
          {
            size: 2.5,
            price: 25,
          },
          {
            size: 3,
            price: 30,
          },
          {
            size: 3.5,
            price: 35,
          },
          {
            size: 4,
            price: 40,
          },
          {
            size: 4.5,
            price: 45,
          },
          {
            size: 5,
            price: 50,
          },
        ],
      };
      this.crops = [];
      this.frames = {
        list: [
          // {
          // 	name : "MetalBlack",
          // 	category : 1
          // },
          // {
          // 	name : "MatalSilver",
          // 	category : 1
          // },
          // {
          // 	name : "MetalGold",
          // 	category : 1
          // },
          // {
          // 	name : "WoodBlack",
          // 	category : 2
          // },
          // {
          // 	name : "WoodWhite",
          // 	category : 2
          // },
          {
            name: "PVCBlack",
            category: 3,
            title: "Black",
          },
          {
            name: "PVCWhite",
            category: 3,
            title: "White",
          },
        ],
        category: [
          // {
          // 	id : 1,
          // 	title : "Metal Framing",
          // 	name : "metal"
          // },
          // {
          // 	id : 2,
          // 	title : "Wood Framing",
          // 	name : "wood"
          // },
          {
            id: 3,
            title: "PVC Framing",
            name: "pvc",
          },
        ],
      };
      this.sizes = [
        {
          size: "8-8",
          pvc: 50.0,
          orientation: "",
          matte: "2.5-2.5",
        },
        {
          size: "12-12",
          pvc: 75.0,
          orientation: "",
          matte: "2.5-2.5",
        },
        {
          size: "16-16",
          pvc: 95.0,
          orientation: "",
          matte: "2.5-2.5",
        },
        {
          size: "20-20",
          pvc: 115.0,
          orientation: "",
          matte: "2.5-2.5",
        },
        {
          size: "24-24",
          pvc: 125.0,
          orientation: "",
          matte: "2.5-2.5",
        },
        {
          size: "8-10",
          pvc: 27.0,
          orientation: "",
          matte: "2-2",
        },
        {
          size: "12-16",
          pvc: 40.0,
          orientation: "",
          matte: "2-2",
        },
        {
          size: "16-20",
          pvc: 55.0,
          orientation: "",
          matte: "2-2",
        },
        {
          size: "20-28",
          pvc: 75.0,
          orientation: "",
          matte: "2-4",
        },
        {
          size: "24-36",
          pvc: 125.0,
          orientation: "",
          matte: "2-4",
        },
        {
          size: "10-8",
          pvc: 27.0,
          orientation: "",
          matte: "2-2",
        },
        {
          size: "16-12",
          pvc: 40.0,
          orientation: "",
          matte: "2-2",
        },
        {
          size: "20-16",
          pvc: 55.0,
          orientation: "",
          matte: "2-2",
        },
        {
          size: "28-20",
          pvc: 75.0,
          orientation: "",
          matte: "4-2",
        },
        {
          size: "36-24",
          pvc: 125.0,
          orientation: "",
          matte: "4-2",
        },
      ];
    }
  }
  var fp = new fpSet();

  //Start!

  fpStart();

  //functions

  function fpStart() {
    fpDataFix();
    fpFabricCreate();
    fpOptionsSet();
    fpCheckQueryInput();
  }

  function fpCheckQueryInput() {
    fpLoadingShow();

    const url = new URL(window.location.href);
    let imgSrc = url.searchParams.get("imgSrc");

    if (imgSrc != null) {
      fpAddImageFromUrl(imgSrc);
    } else {
      fpLoadingHide();
    }
  }

  function fpAddImageFromUrl(url) {
    var image = new Image();
    image.src = url;
    image.onload = function () {
      fpLoadingHide();

      var newCrop = {
        id: fp.cur.cropId++,
        mainImage: image.src,
        width: image.width,
        height: image.height,
        ratio: image.width / image.height,
        qtn: 1,
        matteSize: 2,
        matteColor: fp.matte.colors[0],
      };

      newCrop.matteColor.index = 0;

      const url = new URL(window.location.href);
      var size = url.searchParams.get("size");
      const urlParams = new URL(window.location.href).searchParams;
      var price = urlParams.get("price");
      if (size != null) {
        let target = fp.sizes.find(item => item.size === size);
        if (target) {
          if (price != null) {
            target.pvc = parseFloat(price); // override promo price
          }
          newCrop.size = target; // ensure correct size auto-selected
        }
      }


      //chosse size
      if (size != null) {
        newCrop.size = fp.sizes.filter((item) => item.size === size)[0];
      } else if (newCrop.ratio >= 0.95 && newCrop.ratio <= 1.05) {
        newCrop.size = fp.sizes.filter(
          (item) => item.orientation === "square"
        )[0];
      } else if (newCrop.ratio < 0.95) {
        newCrop.size = fp.sizes.filter(
          (item) => item.orientation === "portrait"
        )[0];
      } else if (newCrop.ratio > 1.05 && newCrop.ratio <= 2) {
        newCrop.size = fp.sizes.filter(
          (item) => item.orientation === "landscape"
        )[0];
      } else {
        newCrop.size = fp.sizes.filter(
          (item) => item.orientation === "landscape"
        )[0];
      }

      //choose frame
      //first frame of metal category

      newCrop.frame = fp.frames.list.filter((item) => item.category === 3)[0];
      newCrop.frameCategoty = fp.frames.category.filter(
        (item) => item.id === 3
      )[0];

      //

      fp.crops.push(newCrop);
      fp.cur.crop = newCrop;

      $("#framedPrintsBannerCover").hide();
      $(".fp").css("display", "flex");

      if ($("#fpUploadBox").is(":visible")) {
        fpEditorOpen();
      }

      fpEditorUpadte(true);
      fpCropListUpdate();
      fpMockupUpdate();
    };
  }

  function fpDataFix() {
    //sizes list
    var id = 1;
    fp.sizes.forEach(function (item, i) {
      //id
      fp.sizes[i].id = id++;

      //dimentions
      fp.sizes[i].width = parseFloat(item.size.split("-")[0]);
      fp.sizes[i].height = parseFloat(item.size.split("-")[1]);
      fp.sizes[i].ratio = fp.sizes[i].width / fp.sizes[i].height;

      //orientation
      if (fp.sizes[i].orientation === "panorama") {
        fp.sizes[i].orientation = "panorama";
      } else if (fp.sizes[i].ratio === 1) {
        fp.sizes[i].orientation = "square";
      } else if (fp.sizes[i].ratio > 1 && fp.sizes[i].ratio < 2.1) {
        fp.sizes[i].orientation = "landscape";
      } else {
        fp.sizes[i].orientation = "portrait";
      }
    });

    //frames list

    id = 1;
    fp.frames.list.forEach(function (item, i) {
      //id
      fp.frames.list[i].id = id++;
    });
  }

  function fpLoadingShow(text = "Processing") {
    $("#fpLoadingText").html(text);
    $("#fpLoading").css("display", "flex");
  }

  function fpLoadingHide() {
    $("#fpLoading").hide();
  }

  function fpFabricCreate() {
    //create
    fp.fabric.canvas = new fabric.Canvas("canvas");
    fp.fabric.canvas.set({
      uniScaleTransform: false,
      enableRetinaScaling: true,
      uniScaleKey: "none",
      selection: false,
      containerClass: "fp.fabric.canvasArea",
      controlsAboveOverlay: true,
      backgroundColor: "#fff",
    });

    //PreventMovingOverflow
    fp.fabric.canvas.on("object:moving", function (options) {
      fpFabricPreventMovingOverflow(options);
      fpMockupUpdate();
    });
  }

  function fpFabricPreventMovingOverflow(options) {
    if (!options.target) return;

    let tgHeight = fpFabricGetHeight(options.target);
    let tgWidth = fpFabricGetWidth(options.target);
    let tgTop = fpFabricGetTop(options.target);
    let tgLeft = fpFabricGetLeft(options.target);
    let tgBottom = tgHeight + tgTop;
    let tgRight = tgWidth + tgLeft;

    if (tgLeft > 0) {
      fpFabricSetLeft(options.target, 0);
    }
    if (tgTop > 0) {
      fpFabricSetTop(options.target, 0);
    }
    if (tgRight < fp.fabric.canvas.getWidth()) {
      fpFabricSetLeft(options.target, fp.fabric.canvas.getWidth() - tgWidth);
    }
    if (tgBottom < fp.fabric.canvas.getHeight()) {
      fpFabricSetTop(options.target, fp.fabric.canvas.getHeight() - tgHeight);
    }
  }

  function fpCropAdd(file) {
    if (fp.crops.length > 0) {
      fpCropSave();
    }

    fpLoadingShow();

    if (file.length > 1) {
      fpLoadingHide();
      alert("Just one image file should be select.");
      return;
    }
    file = file[0];
    if (!file.type.match("image")) {
      fpLoadingHide();
      alert(file.name + " is not image file");
      return;
    }
    let picReader = new FileReader();
    picReader.readAsDataURL(file);
    picReader.onerorr = function () {
      fpLoadingHide();
      alert("Can't read this file : " + file.name);
    };
    picReader.onload = function () {
      var image = new Image();
      image.src = picReader.result;
      image.onload = function () {
        fpLoadingHide();

        var newCrop = {
          id: fp.cur.cropId++,
          mainImage: image.src,
          width: image.width,
          height: image.height,
          ratio: image.width / image.height,
          qtn: 1,
          matteSize: 2,
          matteColor: fp.matte.colors[0],
        };

        newCrop.matteColor.index = 0;

        //chosse size
        if (newCrop.ratio >= 0.95 && newCrop.ratio <= 1.05) {
          newCrop.size = fp.sizes.filter(
            (item) => item.orientation === "square"
          )[0];
        } else if (newCrop.ratio < 0.95) {
          newCrop.size = fp.sizes.filter(
            (item) => item.orientation === "portrait"
          )[0];
        } else if (newCrop.ratio > 1.05 && newCrop.ratio <= 2) {
          newCrop.size = fp.sizes.filter(
            (item) => item.orientation === "landscape"
          )[0];
        } else {
          newCrop.size = fp.sizes.filter(
            (item) => item.orientation === "panorama"
          )[0];
        }

        //choose frame
        //first frame of metal category

        newCrop.frame = fp.frames.list.filter((item) => item.category === 3)[0];
        newCrop.frameCategoty = fp.frames.category.filter(
          (item) => item.id === 3
        )[0];

        //

        fp.crops.push(newCrop);
        fp.cur.crop = newCrop;

        $("#framedPrintsBannerCover").hide();
        $(".fp").css("display", "flex");

        if ($("#fpUploadBox").is(":visible")) {
          fpEditorOpen();
        }

        fpEditorUpadte(true);
        fpCropListUpdate();
        fpMockupUpdate();
      };
    };
  }

  function fpEditorUpadte(isNewUpload = false) {
    fpFabricImageUpdate(function () {
      fpOptionsUpdate();
      fpMockupUpdate();
    });
  }

  function fpEditorOpen() {
    $("#framedStart,.sh-tab-wise-img-2-section").hide();
    $("#fpUploadBox").hide();

    $("#fpEditor").css("display", "flex");
  }

  function fpFabricImageUpdate(callBack = function () {}) {
    fpLoadingShow();

    var image = new Image();
    image.crossOrigin = 'anonymous';
    image.src = fp.cur.crop.mainImage;
    
    
    image.onload = function () {
      //clean fabric
      if (fp.fabric.canvas._objects[0] != undefined) {
        fp.fabric.canvas.remove(fp.fabric.canvas._objects[0]);
      }

      //make and add element
      var imgInstance = new fabric.Image(image, {
        left: 0,
        top: 0,
        opacity: 1,
        hasRotatingPoint: false,
        transparentCorners: false,
        hasControls: false,
        centeredRotation: true,
      });
      fp.fabric.canvas.add(imgInstance);

      //set ratio
      fpFabricRatioUpdate();
      fp.fabric.canvas.renderAll();

      fpLoadingHide();
      callBack();
    };
  }

  function fpFabricRatioUpdate() {
    var ratio = fp.cur.crop.size.ratio;
    var maxHeight = fp.def.fabric.maxHeight;
    var maxWidth = $("#fpLeft").width();

    var canvasHeight = maxWidth / ratio;

    if (canvasHeight >= maxHeight) {
      fp.fabric.canvas.setWidth(maxHeight * ratio).setHeight(maxHeight);
    } else {
      fp.fabric.canvas.setWidth(canvasHeight * ratio).setHeight(canvasHeight);
    }

    fpFabricImageFit();
    fp.fabric.canvas.renderAll();
  }

  function fpFabricImageFit() {
    //restore zoom
    $("#fpLeftCropActionsZoomSlider").val(0);

    if (fp.cur.zoom.min !== undefined) {
      fpFabricActionZoom(0);
    }

    //fit image
    let imgInstance = fp.fabric.canvas._objects[0];

    let imgRaito =
      fpFabricGetWidth(imgInstance) / fpFabricGetHeight(imgInstance);
    let imgWidth = fpFabricGetWidth(imgInstance);
    let imgHeight = fpFabricGetHeight(imgInstance);

    let trgRaito = fp.fabric.canvas.getWidth() / fp.fabric.canvas.getHeight();
    let trgWidth = fp.fabric.canvas.getWidth();
    let trgHeight = fp.fabric.canvas.getHeight();

    if (imgRaito <= trgRaito) {
      fpFabricSetWidth(imgInstance, trgWidth);
      fpFabricSetTop(
        imgInstance,
        -((imgHeight * (trgWidth / imgWidth) - trgHeight) / 2)
      );
      fpFabricSetLeft(imgInstance, 0);
    } else {
      fpFabricSetHeight(imgInstance, trgHeight);
      fpFabricSetLeft(
        imgInstance,
        -((imgWidth * (trgHeight / imgHeight) - trgWidth) / 2)
      );
      fpFabricSetTop(imgInstance, 0);
    }
    fp.cur.zoom.min = imgInstance.scaleX;
  }

  function fpFabricActionZoom(zoomVal) {
    fp.cur.zoom.count = (zoomVal / 100) * fp.cur.zoom.max + 1;

    var imageObj = fp.fabric.canvas._objects[0];

    imageObj.scaleX = fp.cur.zoom.min * fp.cur.zoom.count;
    imageObj.scaleY = fp.cur.zoom.min * fp.cur.zoom.count;
    fp.fabric.canvas.renderAll();

    let tgHeight = fpFabricGetHeight(imageObj);
    let tgWidth = fpFabricGetWidth(imageObj);
    let tgTop = fpFabricGetTop(imageObj);
    let tgLeft = fpFabricGetLeft(imageObj);
    let tgBottom = tgHeight + tgTop;
    let tgRight = tgWidth + tgLeft;

    if (tgLeft > 0) {
      fpFabricSetLeft(imageObj, 0);
    }
    if (tgTop > 0) {
      fpFabricSetTop(imageObj, 0);
    }
    if (tgRight < fp.fabric.canvas.getWidth()) {
      fpFabricSetLeft(imageObj, fp.fabric.canvas.getWidth() - tgWidth);
    }
    if (tgBottom < fp.fabric.canvas.getHeight()) {
      fpFabricSetTop(imageObj, fp.fabric.canvas.getHeight() - tgHeight);
    }

    fp.fabric.canvas.renderAll();

    fpMockupUpdate();
  }

  function fpFabricGetLeft(obj) {
    if (fp.cur.angle == 0 || fp.cur.angle == 270) return obj.left;
    else if (fp.cur.angle == 90 || fp.cur.angle == 180)
      return obj.left - fpFabricGetWidth(obj);
  }

  function fpFabricSetLeft(obj, val) {
    if (fp.cur.angle == 0 || fp.cur.angle == 270) obj.left = val;
    else if (fp.cur.angle == 90 || fp.cur.angle == 180)
      obj.left = val + fpFabricGetWidth(obj);
    fp.fabric.canvas.renderAll();
  }

  function fpFabricGetTop(obj) {
    if (fp.cur.angle == 0 || fp.cur.angle == 90) return obj.top;
    else if (fp.cur.angle == 180 || fp.cur.angle == 270)
      return obj.top - fpFabricGetHeight(obj);
  }

  function fpFabricSetTop(obj, val) {
    if (fp.cur.angle == 0 || fp.cur.angle == 90) obj.top = val;
    else if (fp.cur.angle == 180 || fp.cur.angle == 270)
      obj.top = val + fpFabricGetHeight(obj);
    fp.fabric.canvas.renderAll();
  }

  function fpFabricGetWidth(obj) {
    if (fp.cur.angle == 0 || fp.cur.angle == 180) return obj.getScaledWidth();
    else if (fp.cur.angle == 90 || fp.cur.angle == 270)
      return obj.getScaledHeight();
  }

  function fpFabricGetHeight(obj) {
    if (fp.cur.angle == 0 || fp.cur.angle == 180) return obj.getScaledHeight();
    else if (fp.cur.angle == 90 || fp.cur.angle == 270)
      return obj.getScaledWidth();
  }

  function fpFabricSetWidth(obj, val) {
    var scaleX = 1;
    if (fp.cur.angle == 0 || fp.cur.angle == 180) scaleX = val / obj.width;
    else if (fp.cur.angle == 90 || fp.cur.angle == 270)
      scaleX = val / obj.height;
    obj.scaleX = scaleX;
    obj.scaleY = scaleX;
  }

  function fpFabricSetHeight(obj, val) {
    var scaleX = 1;
    if (fp.cur.angle == 0 || fp.cur.angle == 180) scaleX = val / obj.height;
    else if (fp.cur.angle == 90 || fp.cur.angle == 270)
      scaleX = val / obj.width;
    obj.scaleX = scaleX;
    obj.scaleY = scaleX;
  }

  function fpFabricActionRotate() {
    //restore zoom
    $("#fpLeftCropActionsZoomSliderom").val(0);
    fpFabricActionZoom(0);

    //
    var imgObj = fp.fabric.canvas._objects[0];
    fp.cur.angle = (imgObj.angle + 90) % 360;

    imgObj.rotate(fp.cur.angle).setCoords();
    if (fp.cur.angle == 90 || fp.cur.angle == 270) {
      fpFabricSetWidth(imgObj, fp.fabric.canvas.getWidth());
    }

    fpFabricImageFit();
    fp.fabric.canvas.renderAll();
  }

  function fpOptionsSet() {
    //frame list
    fp.frames.category.forEach(function (catgory) {
      $("#fpFrameList").append(
        '<div class="fpFrameListCat">' +
          '<div class="fpFrameListCatTitle" id="' +
          catgory.id +
          '">' +
          catgory.title +
          "</div>" +
          '<div class="fpFrameListCatPrice" id="fpFrameListCatPrice" data-name="' +
          catgory.name +
          '">($NaN)</div>' +
          "<div>"
      );

      var catList = fp.frames.list.filter(
        (item) => item.category === catgory.id
      );

      var frameGroup = '<div class="fpFrameListGroup" id="fpFrameListGroup">';
      catList.forEach(function (frame) {
        frameGroup +=
          '<div id="' +
          frame.id +
          '">' +
          '<img src="' +
          fp.def.serverPath +
          "frames/" +
          frame.name +
          "/thumbnail.jpg" +
          '">' +
          "<span>" +
          frame.title +
          "</span>" +
          "</div>";
      });
      frameGroup += "</div>";

      $("#fpFrameList").append(frameGroup);
    });

    //matte size

    //matte color
    fp.matte.colors.forEach(function (color, index) {
      $("#fpMatteColorList").append(
        '<div style="background:' +
          color.hex +
          '" data-index="' +
          index +
          '"></div>'
      );
    });
  }

  function fpOptionsUpdate(newCrop = false) {
    //clean size list
    $("#fpMiddleSizeListChart").html("");

    //size title set
    $("#fpMiddleSizeListTitle").html(
      fp.cur.crop.size.orientation.toUpperCase()
    );

    //add size list
    let sizeList = fp.sizes.filter(
      (item) => item.orientation === fp.cur.crop.size.orientation
    );
    for (let i = 0; i < sizeList.length; i++) {
      let active = "";
      if (fp.cur.crop.size.id === sizeList[i].id) {
        active = "fpMiddleSizeListChartRowActive";
      }

      $(".fpMiddleSizeListChart").append(
        "<div class='fpMiddleSizeListChartRow clearBoth " +
          active +
          "' id='" +
          sizeList[i].id +
          "' >" +
          "<div class='fpMiddleSizeListChartDimension'> " +
          sizeList[i].width.toString() +
          "×" +
          sizeList[i].height.toString() +
          '"</div>' +
          "<div class='fpMiddleSizeListChartPrice'>$ " +
          sizeList[i].pvc.toFixed(2) +
          "</div>" +
          "</div>"
      );
    }

    //update orientation
    var ori = fp.cur.crop.size.orientation;
    $("#fpLeftCropActionsBtn").find(".active").removeClass("active");
    $("#" + ori).addClass("active");

    //update frame list
    $("#fpFrameList").find(".active").removeClass("active");
    $("#fpFrameList")
      .find("#" + fp.cur.crop.frame.id)
      .addClass("active");

    var prices = $("#fpFrameList").find("div#fpFrameListCatPrice").toArray();
    prices.forEach(function (price) {
      var catName = $(price).attr("data-name");
      $(price).html("$ " + fp.cur.crop.size[catName] + "");
    });

    //update matte options****

    // $("#fpMatteSizeRangeValue").html(fp.cur.crop.matteSize + '"');
    var matte = fp.cur.crop.size.matte.split("-");
    $(".fpMatteSizeTitle").html(
      "Matte Size : " + matte[0] + '" - ' + matte[1] + '"'
    );

    // $("#fpMatteColorList").find(".active").removeClass("active");
    // $("#fpMatteColorList").find("[data-index='" + fp.cur.crop.matteColor.index + "']").addClass("active");

    // if(fp.cur.crop.matteSize > 0)
    // {
    // 	$("#fpMatteSizeNoMatte").html("");
    // }
    // if(fp.cur.crop.matteSize === 0)
    // {
    // 	$("#fpMatteSizeNoMatte").html("No Matte");
    // }

    // var mattePrice = fp.matte.list.filter(item => item.size == fp.cur.crop.matteSize)[0].price;
    // var mattePrice = 0;
    // if(fp.cur.crop.matteSize > 0)
    // {
    // 	mattePrice = Math.round(fp.cur.crop.size[fp.cur.crop.frameCategoty.name] * 0.2);
    // }

    // if(mattePrice === 0)
    // {
    // 	$("#fpMattesTitlePrice").html("");
    // }
    // else
    // {
    // 	$("#fpMattesTitlePrice").html("+ $ " + mattePrice);
    // }
  }

  function fpRatioChange(orientation) {
    fp.cur.crop.size = fp.sizes.filter(
      (item) => item.orientation === orientation
    )[0];

    fpFabricImageUpdate(function () {
      fpOptionsUpdate();
      fpCropListUpdate();
      fpMockupUpdate();
      setTimeout(() => {
        fpMockupUpdate();
      }, 500);
    });
  }

  function fpSizeChange(elm) {
    var id = parseInt($(elm).attr("id"));

    $("#fpMiddleSizeListChart")
      .find(".fpMiddleSizeListChartRowActive")
      .removeClass("fpMiddleSizeListChartRowActive");
    $("#fpMiddleSizeListChart")
      .find("#" + id)
      .addClass("fpMiddleSizeListChartRowActive");

    fp.cur.crop.size = fp.sizes.filter((item) => item.id === id)[0];

    fpFabricImageUpdate(function () {
      fpOptionsUpdate();
      fpCropListUpdate();
      fpMockupUpdate();
    });
  }

  function fpFrameChange(elm) {
    if ($(elm).hasClass(".active")) {
      return;
    }
    var id = $(elm).attr("id");
    fp.cur.crop.frame = fp.frames.list.filter((item) => item.id == id)[0];
    fp.cur.crop.frameCategoty = fp.frames.category.filter(
      (item) => item.id == fp.cur.crop.frame.category
    )[0];

    fpOptionsUpdate();
    fpCropListUpdate();
    fpMockupUpdate();
  }

  function fpCropListUpdate() {
    $("#fpCropsList").html("");

    fp.crops.forEach(function (crop) {
      var active = "";
      if (crop.id === fp.cur.crop.id) {
        active = "active";
      }

      $("#fpCropsList").append(
        '<div id="' +
          crop.id +
          '" class="fpCrop ' +
          active +
          '">' +
          '<div class="fpCroptQtn">' +
          '<div class="fpCroptQtnMines" id="fpCroptQtnMines">‹</div>' +
          '<div class="fpCroptQtnValue">' +
          '<div id="fpCroptQtnValue">' +
          crop.qtn +
          "</div>x" +
          "</div>" +
          '<div class="fpCroptQtnPlus" id="fpCroptQtnPlus">›</div>' +
          "</div>" +
          '<div class="fpCroptType">' +
          crop.size.orientation +
          "</div>" +
          '<div class="fpCroptSize">' +
          crop.size.width +
          "×" +
          crop.size.height +
          '"</div>' +
          '<div class="fpCroptPrice">$ ' +
          fpCropPriceGet(crop).toFixed(2) +
          "</div>" +
          '<div class="fpCroptChange" id="fpCroptChange">CHANGE</div>' +
          '<div class="fpCroptDelete" id="fpCroptDelete">X</div>' +
          "</div>"
      );
    });

    fpFinishUpdate();
  }

  function fpCropListDelete(elm) {
    if (!confirm("Are you sure you want to delete?")) {
      return;
    }

    var cropId = parseInt($(elm).parent().attr("id"));
    var cropIndex = fp.crops.findIndex((item) => item.id == cropId);

    fp.crops.splice(cropIndex, 1);

    if (fp.crops.length === 0) {
      $("#fpUploadBox").show();
      $("#fpEditor").hide();
    }
    if (fp.cur.crop.id == cropId) {
      fp.cur.crop = fp.crops[0];

      fpFabricImageUpdate(function () {
        fpOptionsUpdate();
        fpCropListUpdate();
        fpMockupUpdate();
      });
    } else {
      fpCropListUpdate();
    }
  }

  function fpCropPriceGet(crop) {
    // var mattePrice = fp.matte.list.filter(item => item.size == crop.matteSize)[0].price;
    // var mattePrice = 0;
    // if(crop.matteSize > 0)
    // {
    // 	mattePrice = crop.size[crop.frameCategoty.name] * 0.2;
    // }

    return /*mattePrice + */ crop.size[crop.frameCategoty.name] * crop.qtn;
  }

  function fpFinishUpdate() {
    var totlaPrice = 0;

    fp.crops.forEach(function (crop) {
      totlaPrice += fpCropPriceGet(crop);
    });

    $("#fpFinishTotal").html("$" + totlaPrice.toFixed(2));
  }

  function fpCropListQtnChange(elm) {
    var cropElm = $(elm).parent().parent();
    var cropId = parseInt($(cropElm).attr("id"));
    var cropIndex = fp.crops.findIndex((item) => item.id == cropId);
    var qtnVal = parseInt($(cropElm).find("#fpCroptQtnValue").html());

    if ($(elm).attr("id") === "fpCroptQtnMines") {
      if (qtnVal == 1) {
        return;
      }

      qtnVal--;
      fp.crops[cropIndex].qtn = qtnVal;
      $(cropElm).find("#fpCroptQtnValue").html(qtnVal);

      fpCropListUpdate();
    } else if ($(elm).attr("id") === "fpCroptQtnPlus") {
      qtnVal++;
      fp.crops[cropIndex].qtn = qtnVal;
      $(cropElm).find("#fpCroptQtnValue").html(qtnVal);

      fpCropListUpdate();
    }
  }

  function fpCropListChange(elm) {
    fpCropSave();

    if ($(elm).parent().attr("id") == fp.cur.crop.id) {
      return;
    }

    fp.cur.crop = fp.crops.filter(
      (item) => item.id == $(elm).parent().attr("id")
    )[0];

    fpFabricImageUpdate(function () {
      fpOptionsUpdate();
      fpCropListUpdate();
      fpMockupUpdate();
    });
  }

  function fpMockupUpdate() {
    //def
    var gap = 50; //pixel
    var frameBorder = 0.4; //inch

    //dimentions
    var areaWidth = $("#fpRight").width();
    var areaHeight = $("#fpMockup").height();
    var areaRatio = areaWidth / areaHeight;

    var frameWidth = fp.cur.crop.size.width;
    var frameHeight = fp.cur.crop.size.height;
    var frameRatio = frameWidth / frameHeight;

    var mockupWidth = 0;
    var mockupHeight = 0;

    if (frameRatio >= areaRatio) {
      mockupWidth = areaWidth - gap * 2;
      mockupHeight = mockupWidth / frameRatio;
    } else {
      mockupHeight = areaHeight - gap * 2;
      mockupWidth = mockupHeight * frameRatio;
    }

    //calculate frame width and matte width and image width
    var matteSize = fp.cur.crop.size.matte.split("-");
    var all = frameBorder * 2 + frameWidth;

    var mockupFrameWidth = (frameBorder / all) * mockupWidth;

    var imageWidth = (frameWidth / all) * mockupWidth;

    var mockupFrameMatte = [];

    mockupFrameMatte[0] = ((matteSize[0] / frameWidth) * imageWidth) / 2;
    mockupFrameMatte[1] = ((matteSize[1] / frameWidth) * imageWidth) / 2;

    imageWidth = imageWidth - mockupFrameMatte[0] * 2;

    var imageHeight = imageWidth / frameRatio;

    //***standard calculate****

    // var matteSize = fp.cur.crop.matteSize;
    // var all = (frameBorder * 2) + (matteSize * 2) + frameWidth;

    // var mockupFrameWidth = (frameBorder / all) * mockupWidth;
    // var mockupFrameMatte = (matteSize / all) * mockupWidth;

    // var imageWidth = (frameWidth / all) * mockupWidth;
    // var imageHeight = imageWidth / frameRatio;

    //get image

    var image = new Image();
    image.src = fp.fabric.canvas.toDataURL();

    //border image
    var borderImage =
      fp.def.serverPath + "frames/" + fp.cur.crop.frame.name + "/border.jpg";
    var sideImage =
      fp.def.serverPath + "frames/" + fp.cur.crop.frame.name + "/side.jpg";

    //mattecolor
    var matteColor = fp.cur.crop.matteColor.hex;
    if (mockupFrameMatte[0] == 0) {
      matteColor = "#000";
    }

    image.onload = function () {
      //set css
      $("#fpMockupFrame")
        .css("width", imageWidth + "px")
        .css("height", imageHeight + "px")
        .css("border-width", mockupFrameWidth + "px")
        .css("border-image-source", "url(" + borderImage + ")")
        .css(
          "padding",
          mockupFrameMatte[1] + "px " + mockupFrameMatte[0] + "px"
        )
        .css("background-color", matteColor);
      $("#fpMockupImage").css("background-image", "url(" + image.src + ")");
      $("#fpMockupSide")
        .css("width", mockupFrameWidth + "px")
        .css("background", "url(" + sideImage + ")")
        .css(
          "height",
          imageHeight + mockupFrameWidth * 2 + mockupFrameMatte[1] * 2 + "px"
        )
        .css("right", -mockupFrameWidth + "px")
        .css("top", -mockupFrameWidth + "px")
        .css(
          "transform",
          "rotateY(90deg) translateZ(" +
            mockupFrameWidth / 2 +
            "px) translateY(0px) translateX(" +
            mockupFrameWidth / 2 +
            "px)"
        );
    };
  }

  function fpMatteSizeChange(elm) {
    if ($(elm).attr("id") === "fpMatteSizeRangeMines") {
      if (fp.cur.crop.matteSize === fp.matte.range.min) {
        return;
      }

      if (fp.cur.crop.matteSize === 2) {
        fp.cur.crop.matteSize = 0;
      } else {
        fp.cur.crop.matteSize -= fp.matte.range.step;
      }

      fpOptionsUpdate();
      fpCropListUpdate();
      fpMockupUpdate();
    } else if ($(elm).attr("id") === "fpMatteSizeRangePlus") {
      if (fp.cur.crop.matteSize === fp.matte.range.max) {
        return;
      }

      if (fp.cur.crop.matteSize === 0) {
        fp.cur.crop.matteSize = 2;
      } else {
        fp.cur.crop.matteSize += fp.matte.range.step;
      }

      fpOptionsUpdate();
      fpCropListUpdate();
      fpMockupUpdate();
    }
  }

  function fpMatteColorChange(elm) {
    if ($(elm).hasClass("active")) {
      return;
    }

    fp.cur.crop.matteColor = fp.matte.colors[$(elm).attr("data-index")];
    fp.cur.crop.matteColor.index = $(elm).attr("data-index");

    fpOptionsUpdate();
    fpCropListUpdate();
    fpMockupUpdate();
  }

  function fpAddToCart() {
    fpCropSave();

    fpLoadingShow();

    var cropedImage = [];
    var printSize = "";
    var frameName = "";
    var matteSize = "";
    var matteColor = "";
    var qtn = "";

    fp.crops.forEach(function (crop) {
      printSize += crop.size.size + "\n";
      frameName += crop.frame.name + "\n";
      matteSize += crop.size.matte + "\n";
      matteColor += crop.matteColor.name + "\n";
      qtn += crop.qtn + "\n";

      cropedImage.push(crop.cropedImage);
    });

    var totalPrice = 0;
    fp.crops.forEach(function (crop) {
      totalPrice += fpCropPriceGet(crop);
    });

    fpLoadingHide();

    canadaUploader(cropedImage, "framedPrint", "jpeg", function (response) {

      var formData = new FormData();

      formData.append("order_url", response);
      formData.append("order_size", printSize);
      formData.append("order_name", frameName);
      formData.append("order_matte_size", matteSize);
      formData.append("order_matte_color", matteColor);
      formData.append("order_quanity", qtn);
      formData.append("price", totalPrice);
      formData.append("title", "Framed Prints");
      formData.append("product_type","FramedPrints");
      formData.append("image_url", response.split("\n")[0].trim());

      $.ajax({
        url: "https://www.canadaphotolab.com/wp-content/themes/printspace/shopify/create_draft_order.php",
        method: "POST",
        data: formData,
        contentType: false,
        processData: false,
        dataType: "json",
        success: function (response) {
          if (response.success) {
            window.location.href = response.url;
          } else {
            alert("Error: " + (response.message || "Something went wrong"));
            console.log(response);
          }
        },
        error: function (xhr, status, error) {
          alert("AJAX error: " + xhr.responseText + " " + status + " " + error);
          console.log(xhr.responseText);
        },
      });
    });
  }

  function fpCropSave() {
    var multiplier =
      (fp.cur.crop.size.width * fp.def.exportDpi) / fp.fabric.canvas.width;
    var image = fp.fabric.canvas.toDataURL({
      format: "jpeg",
      multiplier: multiplier,
    });

    fp.cur.crop.cropedImage = changeDpiDataUrl(image, fp.def.exportDpi);
  }

  //actions
  $("#fpCropsList").on("click", "#fpCroptDelete", function () {
    fpCropListDelete(this);
  });

  $("#fpMatteSizeRange").on("click", ">div", function () {
    fpMatteSizeChange(this);
  });

  $("#fpMatteColorList").on("click", ">div", function () {
    fpMatteColorChange(this);
  });

  $("#fpCropsList").on(
    "click",
    "#fpCroptQtnMines,#fpCroptQtnPlus",
    function () {
      fpCropListQtnChange(this);
    }
  );

  $("#fpCropsList").on("click", "#fpCroptChange", function () {
    fpCropListChange(this);
  });

  $("#fpFrames").on("click", "#fpFrameListGroup>div", function () {
    fpFrameChange(this);
  });

  $("#fpUploadBoxArea").click(function () {
    $("#fpUploadBoxInput").val("");
    $("#fpUploadBoxInput").click();
  });

  $("#fpLeftUploadBtn,#framedStart,.sh-twi-2-tab-item:eq(2) .sh-twi-2-tab-item-media p ").click(function () {
    $("#fpUploadBoxInput").val("");
    $("#fpUploadBoxInput").click();
  });

  $("#fpUploadBoxInput").change(function (e) {
    fpCropAdd(e.target.files);
  });

  $(document).on("input", "#fpLeftCropActionsZoomSlider", function () {
    fpFabricActionZoom($(this).val());
  });

  $("#fpRotatePic").click(function () {
    fpFabricActionRotate();
  });

  $("#fpLeftCropActionsBtn").on("click", ">div", function () {
    if ($(this).attr("id") === "fpRotatePic") {
      return;
    } else if ($(this).attr("id") === fp.cur.crop.size.orientation) {
      return;
    }

    fpRatioChange($(this).attr("id"));
  });

  $("#fpMiddleSizeListChart").on("click", ">div", function () {
    fpSizeChange(this);
  });

  $(".fpFinishBtnAddToCartLable").click(function () {
    fpAddToCart();
  });
});
